import { clsx } from 'clsx';
import { FC } from 'react';

import { IconOdometer } from 'src/general/Icons/IconOdometer';
import { IconPetrol } from 'src/general/Icons/IconPetrol';
import { IconTransmission } from 'src/general/Icons/IconTransmission';
import { SvgIcon } from 'src/general/Icons/SvgIcon.type';
import { formatNumber } from 'src/general/helpers/formatNumber';
import { BaseCarData } from 'src/types/Car.types';

interface Props {
  carData: BaseCarData;
  className?: string;
}

const carDetails: {
  title: string;
  Icon: FC<SvgIcon>;
  valueKey: keyof BaseCarData;
  formatter?: (value: any) => string;
}[] = [
  {
    title: 'Odometer',
    Icon: IconOdometer,
    valueKey: 'kilometers',
    formatter: (value) => formatNumber(value, { append: ' km' }),
  },
  {
    title: 'Fuel type',
    Icon: IconPetrol,
    valueKey: 'fuelType',
  },
  {
    title: 'Transmission',
    Icon: IconTransmission,
    valueKey: 'transmission',
  },
];

export const CarPriceCardDetails: FC<Props> = ({ carData, className }) => (
  <dl className={clsx('mt-2 flex items-start justify-center gap-5', className)}>
    {carDetails.map(({ title, Icon, valueKey, formatter }) => (
      <div key={title} className="inline-flex items-center justify-start gap-0.5">
        <dt className="flex h-5 text-lg">
          <Icon size={20} />
        </dt>
        <dd className="c-fs-caption m-0 font-normal">{formatter ? formatter(carData[valueKey]) : carData[valueKey]}</dd>
      </div>
    ))}
  </dl>
);
